var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { toNumber } from '../../../../utils/helper/lodash_replacements';
export class LocationSteps {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get location() {
        return this.parent;
    }
    /* Path splitting */
    get pathURIpieces() {
        return this.location.pathURI.split('/');
    }
    get depth() {
        return (this.pathURIpieces.length - 1);
    }
    get pathnamepieces() {
        return this.location.pathname.split('/');
    }
    get parentPathURI() {
        return this.pathURIpieces.slice(0, this.pathURIpieces.length - 1).join('/');
    }
    get filename() {
        return this.pathURIpieces[this.pathURIpieces.length - 1];
    }
    /* LOCATION ENTITIES */
    get parentLocation() {
        return this.location.parent.model.stream.path[this.parentPathURI];
    }
    get instance() {
        return this.location.parent.model.stream.path[this.subPathURIByDepth(0)];
    }
    get schooltype() {
        if (this.depth < 1)
            return null;
        return this.location.parent.model.stream.path[this.subPathURIByDepth(1)];
    }
    get form() {
        if (this.depth < 2)
            return null;
        return this.location.parent.model.stream.path[this.subPathURIByDepth(2)];
    }
    get subject() {
        if (this.depth < 3)
            return null;
        return this.location.parent.model.stream.path[this.subPathURIByDepth(3)];
    }
    get category() {
        if (this.depth < 4)
            return null;
        return (this.location.type === 'topic' && this.depth > 4 && this.location.parent.model.stream.path[this.subPathURIByDepth(4)]) || null;
    }
    get allSteps() {
        return [this.instance, this.schooltype, this.form, this.subject, this.category].filter(p => p);
    }
    get areStepPathsLoaded() {
        return this.allSteps.length === this.depth;
    }
    get categoryOrTopic() {
        if (this.depth < 4)
            return null;
        return this.location.parent.model.stream.location[this.subPathURIByDepth(4)];
    }
    get deepTopic() {
        if (this.depth < 5)
            return null;
        return this.location.parent.model.stream.topic[this.subPathURIByDepth(5)];
    }
    subPathURIByDepth(depth) {
        if (depth > this.pathURIpieces.length)
            return 'Ungültige Tiefe';
        return this.pathURIpieces.slice(0, depth + 1).join('/');
    }
    /* ONLY BASIC LOCATION DATA */
    get triggeredSolidPathNeighbourData() {
        return (this.parentLocation && this.parentLocation).pathChildren.pathChildrenQuery.streamedRef || [];
    }
    get schooltypeUrl() {
        return this.pathURIpieces.length > 1 ? this.pathURIpieces[1] : '';
    }
    get formUrl() {
        return this.pathURIpieces.length > 2 ? this.pathURIpieces[2] : '';
    }
    get subjectUrl() {
        return this.pathURIpieces.length > 3 ? this.pathURIpieces[3] : '';
    }
    get categoryUrl() {
        return this.pathURIpieces.length > 4 ? this.pathURIpieces[4] : '';
    }
    get category2Url() {
        return this.pathURIpieces.length > 5 ? this.pathURIpieces[5] : '';
    }
    get schooltypeName() {
        return this.pathnamepieces.length > 1 ? this.pathnamepieces[1] : '';
    }
    get formName() {
        return this.pathnamepieces.length > 2 ? this.pathnamepieces[2] : '';
    }
    get subjectName() {
        return this.pathnamepieces.length > 3 ? this.pathnamepieces[3] : '';
    }
    get categoryName() {
        return this.pathnamepieces.length > 4 ? this.pathnamepieces[4] : '';
    }
    get category2Name() {
        return this.pathnamepieces.length > 5 ? this.pathnamepieces[5] : '';
    }
    get formNumber() {
        return this.formUrl === 'oberstufe' ? 12 : toNumber(this.formUrl.slice(-1));
    }
}
__decorate([
    computed
], LocationSteps.prototype, "parentLocation", null);
__decorate([
    computed
], LocationSteps.prototype, "instance", null);
__decorate([
    computed
], LocationSteps.prototype, "schooltype", null);
__decorate([
    computed
], LocationSteps.prototype, "form", null);
__decorate([
    computed
], LocationSteps.prototype, "subject", null);
__decorate([
    computed
], LocationSteps.prototype, "category", null);
__decorate([
    computed
], LocationSteps.prototype, "areStepPathsLoaded", null);
__decorate([
    computed
], LocationSteps.prototype, "categoryOrTopic", null);
__decorate([
    computed
], LocationSteps.prototype, "deepTopic", null);
__decorate([
    computed
], LocationSteps.prototype, "triggeredSolidPathNeighbourData", null);
